import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=3b0f90d0&scoped=true&"
import script from "./Notfound.vue?vue&type=script&lang=js&"
export * from "./Notfound.vue?vue&type=script&lang=js&"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=3b0f90d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f90d0",
  null
  
)

export default component.exports